import type {UserEvent, UserEventDetailComponentProps} from '@cohort/merchants/apps';
import {formatDetailComponentBoldText} from '@cohort/merchants/apps/cohort/utils/format';
import {getCampaignRoute} from '@cohort/merchants/lib/Pages';
import type {CohortRewardBoxUnlockedEventStruct} from '@cohort/shared/apps/cohort/userEvents/reward/rewardBoxUnlocked';
import {CohortRewardBoxUnlockedEventSpec} from '@cohort/shared/apps/cohort/userEvents/reward/rewardBoxUnlocked';
import {Trans} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

const DetailComponent: React.FC<UserEventDetailComponentProps> = ({userEvent}) => {
  const properties = userEvent.properties as CohortRewardBoxUnlockedEventStruct['Properties'];
  const {campaignId, campaignInternalName} = properties;
  const navigate = useNavigate();
  return (
    <Trans
      i18nKey="userEvents.reward-box.unlocked.detail"
      ns="app-cohort"
      values={{
        campaignInternalName,
      }}
      components={{
        bold: formatDetailComponentBoldText(userEvent, () => {
          if (campaignId) {
            navigate(getCampaignRoute(campaignId).path);
          }
        }),
      }}
    />
  );
};

export const CohortRewardBoxUnlockedUserEvent: UserEvent<CohortRewardBoxUnlockedEventStruct> = {
  spec: CohortRewardBoxUnlockedEventSpec,
  detailComponent: DetailComponent,
};
